<template>
	<PopupRouterViewApprovalDetail label="Purchase Request Input" @approveMethod="submitAction"
		:showApproveButton="isAllowSubmit" approveButtonTitle="Submit Request" approveButtonVariant="success"
		@rejectMethod="saveAction" :showRejectButton="isAllowSaveDraft" rejectButtonTitle="Save As Draft"
		rejectButtonVariant="danger" :showRevisionButton="false" :showApprovalHistoryButton="false" :showLeftIcon="true"
		:isBusy="isBusy">

		<b-card header="Purchase Request" class="mb-3 card-max-width">
			<b-row>
				<b-col cols="12" lg="6">
					<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Purchase Request Number"
						:model="model.purchaseRequestNumber" v-if="!model.isManualNumber" />
					<app-input-textbox :id="'fieldset-purchase-request-number'" label-cols-lg="12" label="Purchase Request Number"
					size="sm" :model.sync="model.purchaseRequestNumber" @change="updateData" :isRequired="true" :isEditable="model.mainRecordId != null ? false : true" v-if="model.isManualNumber" />

					<app-input-combobox-autocomplete :options="partClassifications" optionsLabel="code" optionsKey="id"
						label-cols-lg="12" label="Part Classification" id="fieldset-part-classification" size="sm"
						:model.sync="model.partClassificationId"
						:selected="model.partClassification != null ? model.partClassification.code : ''"
						@input="getPartClassifications" @change="updateDataClassification" :isEditable="true"
						:isSelectMethodExists="true" @onSelectMethod="updateDataClassification"
						:state="validateState('partClassificationId')"
						:errorMessage="getErrorMessage(errorMessage.partClassificationId, 'partClassificationId')"
						:isRequired="true" />
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id"
						label-cols-lg="12" label="Vendor" id="fieldset-vendor" size="sm" :model.sync="model.vendorId"
						:selected="model.vendor != null ? model.vendor.code : ''" @input="getVendors"
						@change="updateDataVendor" :isEditable="true" :isSelectMethodExists="true"
						:state="validateState('vendorId')"
						:errorMessage="getErrorMessage(errorMessage.vendorId, 'vendorId')"
						@onSelectMethod="updateDataVendor" :reloadData="true" :isRequired="true" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-datepicker id="fieldset-purchase-request-date" label-cols-lg="12"
						label="Purchase Request Date" size="sm" :model.sync="model.purchaseRequestDate"
						:min="minDatePurchaseRequest"
						:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
						@change="updateTanggalPurchaseRequest" :isEditable="true" />
					<app-input-datepicker id="fieldset-delivery-date" label-cols-lg="12" label="Delivery Date" size="sm"
						:model.sync="model.deliveryDate" :min="minDateDelivery"
						:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
						@change="updateData" :isEditable="true" />
					<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark" label-for="input-remark"
						size="sm" :model.sync="model.remark" @change="updateData" :isEditable="true" />
				</b-col>

			</b-row>
		</b-card>

		<app-table-input title="Purchase Request Detail" :bordered="true" :items="purchaseRequestDetails"
			:fields="fieldsPurchaseRequestDetail" :busy="isDataLoading" :sort-by.sync="sortByPurchaseRequestDetail"
			:sort-desc.sync="sortDescPurchaseRequestDetail" small responsive
			@editButtonMethod="editRowDataPurchaseRequestDetail"
			@deleteButtonMethod="deleteRowDataPurchaseRequestDetail"
			@showPopupAddMethod="addDataPurchaseRequestDetail()"
			@showPopupUploadMethod="showPopupUploadPurchaseRequestDetail()"
			@downloadMethod="downloadPurchaseRequestDetail()"
			@addFromClipboardMethod="addFromClipboardPurchaseRequestDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardPurchaseRequestDetail()" :showActionButton="true"
			:showDeleteButton="true" :showAddButton="isShowAddButton" :showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false" :showUploadButton="isShowAddButton" :showDownloadButton="true"
			:isDownloadBusy="isDownloadPurchaseRequestDetail">

			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowPurchaseRequestDetailFilter = !isShowPurchaseRequestDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->

			<template #top-row v-if="isShowPurchaseRequestDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Part Number">
					<v-select id="input-purchase-request-detail-part-table" append-to-body label="partNumber"
						:options="parts" :value="filterPurchaseRequestDetail.partId" :reduce="item => item.id"
						v-model="filterPurchaseRequestDetail.partId" @search="getParts" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty">
					<b-form-input id="input-purchase-request-detail-qty-table" v-model="filterPurchaseRequestDetail.qty"
						size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>

			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + (purchaseRequestDetailPageSize * (currentPurchaseRequestDetailPage - 1))) }}
			</template>

			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>

			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="partDetails" optionsLabel="partNameCombination"
					optionsKey="id" :id="'input-purchase-request-detail-part-' + row.index" label-cols-lg="12"
					label="Part Number" size="sm" :model.sync="row.item.partId" :state="validateState('partId')"
					:errorMessage="getErrorMessage(errorMessage.partId, 'partId')"
					@change="savePartPurchaseRequestDetail(row.item)"
					:selected="row.item.partNameCombination != null ? row.item.partNameCombination : ''"
					@input="getPartsVw" :loading="isPartComboLoading" :isEditable="true" :nolabel="true"
					:reloadData="true" />
			</template>
			<!-- <template v-slot:cell(partName)="row">
				<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
			</template> -->
			<template v-slot:cell(qty)="row">
				<app-input-textbox :id="'input-purchase-request-detail-qty-' + row.index" label-cols-lg="12" label="Qty"
					size="sm" :model.sync="row.item.qty" :state="validateState('qty')"
					:errorMessage="getErrorMessage(errorMessage.qty, 'qty')"
					@change="saveInputPurchaseRequestDetail(row.item)" :isEditable="true" :nolabel="true"
					:thousandSeparator="true" />
			</template>
			<template v-slot:cell(uomPo)="row">
				<app-label label-cols-lg="12" size="sm" label="uomPo"
					:model="(row.item.part != null) ? row.item.part.uomPoCode : null" />
			</template>
			<template v-slot:cell(customerCode)="row">
				<app-label label-cols-lg="12" size="sm" label="customerCode"
					:model="(row.item.part != null) ? row.item.part.customerCode : null" />
			</template>


			<template v-slot:form-add-detail>
				<PurchaseRequestDetailInput :model="modelPurchaseRequestDetail"
					:openPopup="isShowPopupPurchaseRequestDetail" @resetMethod="resetModal"
					@addButtonMethod="addRowDataPurchaseRequestDetail" />
			</template>
			<template v-slot:upload-detail>
				<PurchaseRequestDetailUpload :openPopup="isShowPopupUploadPurchaseRequestDetail"
					@resetMethod="resetModal" @uploadButtonMethod="uploadDataPurchaseRequestDetail"
					:parentId="modelId" />
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentPurchaseRequestDetailPage"
				:total-rows="totalPurchaseRequestDetailRow"
				:per-page="purchaseRequestDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>

		<b-card header="Summary" class="mb-3 card-max-width">
			<b-row>
				<b-col cols="2" lg="2" class="mt-2">
					<span class="font-weight-bold">Total Qty</span>
				</b-col>
				<b-col cols="2" lg="2">
					<app-input-textbox id="total-qty" label-cols-lg="12" label="Qty" size="sm"
						:model.sync="(model.totalQty == null) ? 0 : model.totalQty" :isEditable="false" :nolabel="true"
						:thousandSeparator="true" />
					<!-- <span>: {{ (model.totalQty == null) ? 0 : model.totalQty }}</span> -->
				</b-col>
			</b-row>
		</b-card>

		<template #modal-left-button v-if="this.model.statusId === 'REQUEST FOR REVISION'">
			<b-overlay :show="isBusy" rounded opacity="0.6" spinner-small spinner-variant="primary"
				class="float-right mr-2">
				<b-button @click="resubmitAction()" size="sm" class="float-right btn-default">
					Resubmit Request
				</b-button>
			</b-overlay>
		</template>

		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterViewApprovalDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PurchaseRequest from '@/models/PurchaseRequest/PurchaseRequest';
import PurchaseRequestList from '@/models/PurchaseRequest/PurchaseRequestList';
import PurchaseRequestFilter from '@/filters/PurchaseRequest/PurchaseRequestFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PartClassification from '@/models/PartClassification/PartClassification';
import PartClassificationFilter from '@/filters/PartClassification/PartClassificationFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import VendorType from '@/models/VendorType/VendorType';
import VendorTypeFilter from '@/filters/VendorType/VendorTypeFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import PurchaseRequestDetail from '@/models/PurchaseRequest/PurchaseRequestDetail';
import PurchaseRequestDetailFilter from '@/filters/PurchaseRequest/PurchaseRequestDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PurchaseRequestDetailInput from '@/views/PurchaseRequest/PurchaseRequestDetailInput';
import PurchaseRequestDetailUpload from '@/views/PurchaseRequest/PurchaseRequestDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupRouterViewApprovalDetail from '@/components/PopupRouterViewApprovalDetail';
import VwPartDetails from '@/models/VwPartDetails/VwPartDetails';
import VwPartDetailsFilter from '@/filters/VwPartDetails/VwPartDetailsFilter';
import toast from '@/mixins/toastMixin';

import { mapGetters, mapState, mapActions } from 'vuex';

export default {
	components: {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		AppInputTextbox,
		PurchaseRequestDetailInput, PurchaseRequestDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewApprovalDetail,
		PopupRouterView,
	},
	mixins: [validationMixin, toast],
	validations: {
		model: {
			partClassificationId: { required },
			vendorId: { required },
		},
	},
	data() {
		return {
			errorMessage: {
				partClassificationId: { required: "Part Classification is required" },
				vendorId: { required: "Vendor is required" },
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			fieldsPurchaseRequestDetail: [
				{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "part": { "class": "th-part first-child", "label": "Part", key: 'part', sortable: false } },
				// {"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: false}}, 
				{ "qty": { "class": "th-qty last-child", "label": "Qty", key: 'qty', sortable: false } },
				{ "uomPo": { "class": "th-uomPo d-stack-none", "label": "Uom Po", key: 'uomPo', sortable: false } },
				{ "customerCode": { "class": "th-customer-code d-stack-none", "label": "Customer", key: 'customerCode', sortable: false } },
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPurchaseRequestDetail: {},
			isShowPopupPurchaseRequestDetail: false,
			isShowPopupUploadPurchaseRequestDetail: false,
			filterPurchaseRequest: null,
			currentPurchaseRequestPage: 1,
			purchaseRequestPageSize: 10,
			sortByPurchaseRequest: '',
			sortDescPurchaseRequest: '',
			filterPurchaseRequestDetail: null,
			currentPurchaseRequestDetailPage: 1,
			purchaseRequestDetailPageSize: 10,
			sortByPurchaseRequestDetail: '',
			sortDescPurchaseRequestDetail: '',
			sortingByPurchaseRequestDetail: [],
			purchaseRequestDetails: [],
			purchaseRequestDetailId: '',
			totalPurchaseRequestDetailRow: 0,
			isShowPurchaseRequestDetailFilter: false,
			isDownloadPurchaseRequestDetail: false,
			parts: [],
			partDetails: [],
			partClassifications: [],
			isPartClassificationComboLoading: false,
			vendors: [],
			vendorTypes: [],
			isVendorComboLoading: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			backroute: '',
			isPartClassificationComboLoading: false,
			isVendorComboLoading: false,
			isPartComboLoading: false,
			isPurchaseRequestComboLoading: false,
			minDatePurchaseRequest: new Date(),
			minDateDelivery: new Date(),
		}
	},
	methods: {
		recalculateTotalQty() {
			if (this.purchaseRequestDetails.length > 0) {
				let total = 0;
				this.purchaseRequestDetails.forEach(element => {
					// console.log(element.qty);
					total += parseFloat((element.qty == null) ? 0 : element.qty);
				});
				this.model.totalQty = parseFloat(total);
			}
		},
		updateTanggalPurchaseRequest() {
			if (new Date(this.model.purchaseRequestDate) > new Date(this.model.deliveryDate)) {
				this.model.deliveryDate = this.model.purchaseRequestDate;
			}
			this.minDateDelivery = new Date(this.model.purchaseRequestDate);

			this.$forceUpdate();
			this.updateData();
		},
		getPurchaseRequest: async function (id) {
			this.isBusy = true;
			PurchaseRequest.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPurchaseRequest = true;
			this.filterPurchaseRequest.id = this.modelId;
			PurchaseRequest.downloadDataDetail(this, this.filterPurchaseRequest).then(result => {
				this.isDownloadPurchaseRequest = false;
			}).catch(error => { this.isDownloadPurchaseRequest = false; })
		},
		getPurchaseRequestDetails: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPurchaseRequestDetail);
			if (this.modelId == null) return;
			filter.purchaseRequestId = this.modelId;
			// filter.draftMode = "1";
			if (this.sortByPurchaseRequestDetail != null) {
				this.sortingByPurchaseRequestDetail[this.sortByPurchaseRequestDetail] = this.sortDescPurchaseRequestDetail;
			}
			let currentPage = (this.currentPurchaseRequestDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPurchaseRequestDetailRow + 1;
				let page = Math.ceil(totalData / this.purchaseRequestDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.purchaseRequestDetailPageSize = 0;
			// disable paging end
			PurchaseRequestDetail.getList(this, filter, this.sortingByPurchaseRequestDetail, currentPage, this.purchaseRequestDetailPageSize).then(result => {
				this.currentPurchaseRequestDetailPage = currentPage + 1;
				this.purchaseRequestDetails = result.data;
				this.totalPurchaseRequestDetailRow = result.dataCount;
				this.recalculateTotalQty();
			}).catch(error => { });
		},
		getPurchaseRequests: async function (input) {
			let filter = new PurchaseRequestFilter();
			if (input != undefined) {
				filter.PurchaseRequestNumber = input;
			}
			this.isPurchaseRequestComboLoading = true;
			PurchaseRequest.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseRequests = result.data
					}
					this.isPurchaseRequestComboLoading = false;
				})
				.catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => { });
		},
		getPartsVw: async function (input) {
			let filter = new VwPartDetailsFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}

			var notPartIds = this.purchaseRequestDetails.map(function (row) {
				return row.partId;
			})
			var notPartIdsString = notPartIds.join(',');
			filter.notPartId = notPartIdsString.slice(0, -1);
			filter.partClassificationId = this.model.partClassificationId;
			filter.partVendorId = this.model.vendorId;
			this.isPartComboLoading = true;
			VwPartDetails.getListVw(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.partDetails = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => { });
		},
		getPurchaseRequests: async function (input) {
			let filter = new PurchaseRequestFilter();
			if (input != undefined) {
				filter.purchaseRequestNumber = input;
			}
			this.isPurchaseRequestComboLoading = true;
			PurchaseRequest.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseRequests = result.data
					}
					this.isPurchaseRequestComboLoading = false;
				})
				.catch(error => { });
		},
		getPartClassifications: async function (input) {
			let filter = new PartClassificationFilter();
			if (input != undefined) {
				filter.code = input;
			}
			PartClassification.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.partClassifications = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedPartClassification(item) {
			if (item == undefined || item == null) {
				this.model.partClassificationId = null;
				this.model.partClassification = null;
			} else {
				this.model.partClassificationId = item.id;
				this.model.partClassification = item;
			}
			this.vendors = [];
			this.model.vendorId = null;
			this.$forceUpdate();
			this.updateData();
			//this.updateDataClassification();
		},
		getVendors: async function (input) {
			if (this.model.partClassification != null && this.model.partClassification.code != '') {
				let filter = new VendorFilter();
				if (this.model.partClassification.code === 'WIP' || this.model.partClassification.code === 'FG') {
					filter.vendorTypeId = this.vendorTypes.find(obj => obj.code === 'SUBCONTRACT')?.id;
				} else if (this.model.partClassification.code === 'RM' || this.model.partClassification.code === 'COMPONENT') {
					filter.vendorTypeId = this.vendorTypes.find(obj => obj.code === 'SUPPLIER')?.id;;
				}

				if (input != undefined) {
					filter.code = input;
				}
				Vendor.getList(this, filter, null, 0, 10)
					.then(result => {
						if (result != null) {
							this.vendors = result.data
						}
					})
					.catch(error => { });
			}
			else {
				this.toast({ message: 'Silahkan pilih Part Classification terlebih dahulu', title: 'Alert', variant: 'warning', autoHideDelay: 1000 });
			}
		},
		setSelectedVendor(item) {
			if (item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveAction(modalEvent) {
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				model.statusId = 'DRAFT';
				PurchaseRequest.updateData(this, model, id).then(result => {
					PurchaseRequest.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'purchaserequestinbox' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				model.statusId = 'DRAFT';
				PurchaseRequest.insertData(this, model).then(result => {
					this.$router.push({ name: 'purchaserequestinbox' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		submitAction(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PurchaseRequest.submitApprovalData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'purchaserequestinbox' });
						this.isBusy = false;
						this.getInboxCounter(this);
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		resubmitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				PurchaseRequest.resubmitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'purchaserequestinbox' });
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		updateDataClassification(item) {
			if (this.purchaseRequestDetails.length > 0 || this.model.vendorId != null) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Apakah anda yakin ingin merubah Part Classification? Data Vendor dan data pada tabel Purchase Request Detail akan dihapus.</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e => {
					if (e) {
						this.isBusy = true;
						this.setSelectedPartClassification(item);
						this.purchaseRequestDetails.forEach(element => {
							this.deleteRowDataPurchaseRequestDetail(element.id);
						});
						// this.$forceUpdate();
						// this.updateData();
						this.isBusy = false;
					} else {
						//this.getPurchaseRequest(this.modelId);
						return;
					}
				});
			} else {
				this.setSelectedPartClassification(item);
				
			}

		},
		updateDataVendor(item) {
			if (this.purchaseRequestDetails.length > 0) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Apakah anda yakin ingin merubah Vendor? Data pada tabel Purchase Request Detail akan dihapus.</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e => {
					if (e) {
						this.isBusy = true;
						this.setSelectedVendor(item);
						this.purchaseRequestDetails.forEach(element => {
							this.deleteRowDataPurchaseRequestDetail(element.id);
						});
						this.isBusy = false;
					} else {
						return;
					}
				});
			} else {
				this.setSelectedVendor(item);
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PurchaseRequest.updateData(this, model, id)
						.catch((error) => {
							this.getPurchaseRequest(id);
						});
				}
			});
		},
		onHidden() {
			this.getPurchaseRequests();
		},
		addRowDataPurchaseRequestDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.purchaseRequestId = this.modelId;
					PurchaseRequestDetail.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getPurchaseRequestDetails(true);
							this.isShowPopupPurchaseRequestDetail = false;
						})
				} else {
					model.purchaseRequestId = this.modelId;
					PurchaseRequestDetail.createDataDetail(this, model)
						.then(result => {
							this.getPurchaseRequestDetails(true);
							this.isShowPopupPurchaseRequestDetail = false;
						})
				}
			}
		},
		async editRowDataPurchaseRequestDetail(id) {
			this.purchaseRequestDetailId = id;
			this.isShowPopupPurchaseRequestDetail = true;
		},
		async deleteRowDataPurchaseRequestDetail(id) {
			PurchaseRequestDetail.deleteData(this, id).then(result => { this.getPurchaseRequestDetails(); });
		},
		async resetDataPurchaseRequestDetail() {
			this.purchaseRequestDetailId = "";
			this.isShowPopupPurchaseRequestDetail = true;
		},
		async addDataPurchaseRequestDetail() {
			PurchaseRequestDetail.createData(this, { purchaseRequestId: this.modelId })
				.then(result => {
					this.getPurchaseRequestDetails(true);
				})
		},
		async addFromClipboardPurchaseRequestDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, purchaseRequestId: this.modelId });
				});
				PurchaseRequestDetail.addFromClipboard(this, parts).then(result => { this.getPurchaseRequestDetails() });
			});
		},
		async replaceFromClipboardPurchaseRequestDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, purchaseRequestId: this.modelId });
				});
				PurchaseRequestDetail.replaceFromClipboard(this, parts).then(result => { this.getPurchaseRequestDetails() });
			});
		},
		showPopupUploadPurchaseRequestDetail() {
			if (this.purchaseRequestDetails != null && this.purchaseRequestDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PurchaseRequestDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
					.then(value => {
						if (value) {
							this.isShowPopupUploadPurchaseRequestDetail = true;
						}
					})
					.catch(err => { })
			} else {
				this.isShowPopupUploadPurchaseRequestDetail = true;
			}
		},
		uploadDataPurchaseRequestDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPurchaseRequestDetail = false;
		},
		downloadPurchaseRequestDetail(modalEvent) {
			this.isDownloadPurchaseRequestDetail = true;
			this.filterPurchaseRequestDetail.purchaseRequestId = this.modelId;
			PurchaseRequestDetail.downloadDataDetail(this, this.filterPurchaseRequestDetail).then(result => {
				this.isDownloadPurchaseRequestDetail = false;
			}).catch(error => { this.isDownloadPurchaseRequestDetail = false; })
		},
		savePartPurchaseRequestDetail(item) {
			let existingData = this.purchaseRequestDetails.filter(existingItem => existingItem.part?.id === item.partId);
			if (this.purchaseRequestDetails.length > 0 && existingData[0] != null) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: `<p>Part ${existingData[0].part.partNumber} sudah ada di data Purchase Request Detail</p>`
					}
				});
				this.$bvModal.msgBoxOk([msgNode], {
					title: 'Duplicate',
					size: 'sm',
					buttonSize: 'sm',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				});

				item.partId = null;
				item.partNameCombination = null;
			}

			this.saveInputPurchaseRequestDetail(item);
		},
		saveInputPurchaseRequestDetail(item) {
			if (this.partDetails != null && this.partDetails != undefined && this.partDetails.length > 0) {
				item.part = this.partDetails.find(q => q.id == item.partId);
			}
			if (this.purchaseRequests != null && this.purchaseRequests != undefined && this.purchaseRequests.length > 0) {
				item.purchaseRequest = this.purchaseRequests.find(q => q.id == item.purchaseRequestId);
			}

			this.recalculateTotalQty();

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then(async (results) => {
				if (id != '' && id != null && id != undefined) {
				try {
					await PurchaseRequestDetail.updateData(this, item, item.id);
					this.getPurchaseRequestDetails();
				} catch {}
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPurchaseRequestDetail = false;
			this.isShowPopupPurchaseRequestDetail = false;
			if (modalType == 'PurchaseRequestDetail') {
				this.getPurchaseRequestDetails();
			}
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				//this.isShowPurchaseRequestDetailFilter = true;
			}
		},
		...mapActions('inbox', [
            'getInboxCounter',
        ]),
	},
	beforeMount() {
		this.filterPurchaseRequest = new PurchaseRequestFilter();
		this.filterPurchaseRequestDetail = new PurchaseRequestDetailFilter();
		//this.getParts();
		//this.getPurchaseRequests();
		//this.getPartClassifications();
		//this.getVendors();
	},
	async mounted() {
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPurchaseRequest(id);
			} else {
				this.modelId = id;
				this.getPurchaseRequest(id);
			}
		}

		let filter = new VendorTypeFilter();
		VendorType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendorTypes = result.data;
				}
			})
			.catch(error => { });

		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSubmit: {
			get: function () {
				if (this.model.statusId === 'REQUEST FOR REVISION') return false;
				return true;
			}
		},
		isAllowSaveDraft: {
			get: function () {
				if (this.model.statusId === 'APPROVED' || this.model.statusId === 'REQUEST FOR REVISION') return false;

				if (this.model.purchaseRequestNumber != null && !this.model.purchaseRequestNumber.includes("PurchaseRequestDraft")) return false;

			}
		},
		isShowAddButton: {
			get: function () {
				if (this.model.partClassificationId == null || this.model.vendorId == null) return false;
				return true;
			}
		}
	},
	watch: {
		sortByPurchaseRequestDetail: {
			handler: function () {
				this.getPurchaseRequestDetails();
			}
		},
		sortDescPurchaseRequestDetail: {
			handler: function () {
				this.getPurchaseRequestDetails();
			}
		},
		currentPurchaseRequestDetailPage: {
			handler: function () {
				this.getPurchaseRequestDetails();
			}
		},
		purchaseRequestDetailPageSize: {
			handler: function () {
				this.getPurchaseRequestDetails();
			}
		},
		filterPurchaseRequestDetail: {
			handler: function () {
				this.getPurchaseRequestDetails();
			},
			deep: true,
		},
	},
}
</script>
